<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue"
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/vue/20/solid"
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'


const props = defineProps({
  slideCount: {
    type: Number,
    required: true,
  },
})

const myCarousel = ref(null)

const breakpoints = ref({
  0: {
    itemsToShow: 1.1,
  },
  375: {
    itemsToShow: 1.5,
  },
  480:  {
    itemsToShow: 2.2,
  },
  640: {
    itemsToShow: 2.2,
  },
  1024: {
    itemsToShow: 2.2,
  },
  1280: {
    itemsToShow: 3.2,
  },
  1600: {
    itemsToShow: 4.2,
  },
  1768: {
    itemsToShow: 4.5,
  },
  1920: {
    itemsToShow: 5.5,
  },
})

const buttonNext = ref(null)
const buttonPrev = ref(null)


var handlingScroll = false;

const handleScroll = (event) => { 
 
   const deltaY = event.deltaY;



    if(deltaY == 0){
      event.preventDefault();
    }



  
    if(handlingScroll == false) {
      handlingScroll = true
      const delta = event.deltaX;
      if (delta > 0) {
        // Scroll down/right
        myCarousel.value.next()
      } else if (delta < 0) {
        // Scroll up/left
        myCarousel.value.prev()


      }
      setTimeout(()=>{handlingScroll = false}, 200)
    }
 
      

    
};


    onMounted(() => {
       myCarousel.value.$el.addEventListener('wheel', handleScroll);
    });

    onBeforeUnmount(() => {
      if (myCarousel.value) {
        myCarousel.value.$el.removeEventListener('wheel', handleScroll);
      }
    });

</script>

<template>
  <div class="w-full">
    <div class="md:pr-14 relative">
      <carousel
        ref="myCarousel" 
        :items-to-show="1.2" 
        height="auto" 
        :breakpoints="breakpoints" 
        snapAlign="start"
  
        class="w-full"
      >
        <slide v-for="index in slideCount" :key="index">
          <slot :name="`slide-${index}`"> </slot>
        </slide>
        <template #addons>
          <Pagination/>
        </template>
      </carousel>

      <!--<button
        ref="buttonPrev"
        class="hidden md:flex btn btn-ghost swiper-btn-prev"
      >
        <ChevronLeftIcon class="h-10 w-10 text-neutral-alt" aria-hidden="true" />
      </button>-->
      <button
        ref="buttonNext"
        class="hidden md:flex btn btn-link carousel-button carousel-button-next text-neutral-alt hover:dark:text-white"
        @click="()=>{myCarousel.next()}"
      >
        <ChevronRightIcon class="h-14 w-14" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>
<div class="w-16 hover:w-32 bg-blue-500">
</div>
<style>

.carousel {
  padding-bottom: 0.55rem;
  --vc-pgn-active-color: #9f9fa9;
  --vc-pgn-background-color: #d4d4d8;
}

.carousel__viewport {
  @apply w-full;
  padding-bottom: 1rem;
}

.carousel__pagination{
  bottom: 0;
}
.carousel__pagination-button::after {
  @apply !text-base-content/10 dark:bg-white/30 transition-all duration-300;
  width: 0.25rem;
  border-radius: 5px;

}

.carousel__pagination-button::after:hover {
  @apply text-base-content dark:bg-white;
}

.carousel__pagination-button--active:after {
  @apply text-primary dark:bg-white;
  width: 1rem;
}

.carousel-button {
  padding-left: 0;
  padding-right: 0;
  position: absolute;
  top: 40%;
  z-index: 100;
  @apply text-neutral;
}

.carousel-button-next {
  right: -10px;
}

</style>
